<section class="promotion-terms" *ngIf="terms">
    <div class="container-md px-4 pb-4 d-flex flex-column">
        <span class="promotion-terms__title mb-2">{{
            'fe_coupon_promotions_terms_conditions' | translate
        }}</span>
        <div class="promotion-terms__text" [innerHTML]="terms"></div>
    </div>
</section>
